//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosPost, axiosGet } from '../../axios/axios.js'
import OrderAdmittanceUpdateTemplate from './OrderAdmittanceUpdateTemplate.vue'

export default {
  components: {
    OrderAdmittanceUpdateTemplate
  },
  props: {
    orderAdmittance: {
      type: Object,
      default: null
    },
    orderAdmittanceStr: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      openedUpdateTemplate: false
    }
  },
  methods: {
    getButtonName: function (nextState) {
      const state = this.orderAdmittance.state
      if (nextState === 'AD3') {
        if (state === 'AD4') {
          return 'Выдать. Работы возобновлены'
        } else {
          return 'Выдать'
        }
      } else if (nextState === 'AD6') {
        if (state === 'AD3') {
          // Временно убран статус AD5
          // return 'Закрыть со сдачей'
          return 'Закрыть'
        } else {
          return 'Принять наряд'
        }
      }
    },
    checkTransferToNextState: function (nextState) {
      this.$q.loading.show({ spinnerColor: 'blue-11' })

      axiosGet({
        url: 'service/delta/orderadmittance/checkCreate?oaId=' + this.orderAdmittance.id,
        onSuccess: (response) => {
          if (response.data.result && response.data.result.length) {
            const messages = []
            response.data.result.forEach((result) => {
              result.message.forEach((message) => {
                messages.push(message.message)
              })
            })

            this.$d_ask(
              () => {
                this.transferToNextState(nextState)
              },
              messages.join(('\n')) + '.\nПеред выдачей наряд-допуска необходимо закрыть действующий.',
              {},
              { yes: 'Закрыть и продолжить выдачу', cancel: 'Отмена' }
            )
          } else {
            this.transferToNextState(nextState)
          }
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    transferToNextState: function (nextState) {
      const bodyFormData = this.prepareBodyFormData(nextState)
      axiosPost({
        url: '/service/delta/orderadmittance/' + nextState,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        data: bodyFormData,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешное изменение состояния наряд-допуска',
            progress: true,
            timeout: 3000
          })

          this.$emit('update')
        },
        onFailure: (response) => {
          response.message = response.message === 'Не указан срок действия наряда' ? response.message + '. Укажите срок действия и сохраните.' : response.message

          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    create: function (state) {
      this.$q.loading.show({ spinnerColor: 'blue-11' })

      const bodyFormData = new FormData()
      const props = this.getProps(state)
      bodyFormData.set('props', JSON.stringify(props))

      axiosPost({
        url: '/service/delta/orderadmittance/createByTemplate?brigadeId=' + this.orderAdmittance.brigadeId + '&templateId=' + this.orderAdmittance.templateId,
        data: bodyFormData,
        onSuccess: (response) => {
          this.$router.replace('/journals/orderAdmittance/' + response.data.result.id)

          this.$q.notify({
            type: 'positive',
            message: 'Успешное создание наряд-допуска',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    prepareBodyFormData: function (nextState) {
      const bodyFormData = new FormData()
      bodyFormData.set('objectId', this.orderAdmittance.id)

      if (this.orderAdmittanceStr !== JSON.stringify(this.orderAdmittance)) {
        const props = this.getProps(nextState)
        bodyFormData.set('props', JSON.stringify(props))
      }

      return bodyFormData
    },
    getProps: function (nextState) {
      const props = {}

      if (nextState === this.orderAdmittance.state) {
        props.checkReprocess = true
      }

      if (this.orderAdmittance.state !== 'AD5' && this.orderAdmittance.state !== 'AD6' && this.orderAdmittance.state !== 'AD7') {
        if (this.orderAdmittance.performersInstructors) {
          props.performersInstructors = this.orderAdmittance.performersInstructors
        }
        if (this.orderAdmittance.observable && this.orderAdmittance.observersInstructors) {
          props.observersInstructors = this.orderAdmittance.observersInstructors
        }
      }

      if (this.orderAdmittance.state === 'AD0') {
        if (this.orderAdmittance.department && this.orderAdmittance.department.key) {
          props.department = this.orderAdmittance.department.key
        }
      }

      if (this.orderAdmittance.state === 'AD0' || this.orderAdmittance.state === 'AD1' || this.orderAdmittance.state === 'AD2') {
        props.startWorkTime = this.orderAdmittance.startWorkTime
        props.endWorkTime = this.orderAdmittance.endWorkTime
        if (this.orderAdmittance.givingEmployee && this.orderAdmittance.givingEmployee.key) {
          props.givingEmployee = this.orderAdmittance.givingEmployee.key
        }
        if (this.orderAdmittance.receivingEmployee && this.orderAdmittance.receivingEmployee.key) {
          props.receivingEmployee = this.orderAdmittance.receivingEmployee.key
        }
        if (this.orderAdmittance.seniorEmployee && this.orderAdmittance.seniorEmployee.key) {
          props.seniorEmployee = this.orderAdmittance.seniorEmployee.key
        }
        if (this.orderAdmittance.admittingEmployee && this.orderAdmittance.admittingEmployee.key) {
          props.admittingEmployee = this.orderAdmittance.admittingEmployee.key
        }
        if (this.orderAdmittance.foundation && this.orderAdmittance.foundation.length) {
          props.foundation = this.orderAdmittance.foundation.map(foundation => foundation.key)
        } else {
          props.foundation = []
        }
        props.address = this.orderAdmittance.address
      }
      if (this.orderAdmittance.state === 'AD3' || this.orderAdmittance.state === 'AD4') {
        props.prolongeLimitTime = this.orderAdmittance.prolongingEmployee && this.orderAdmittance.prolongingEmployee.limit
        if (this.orderAdmittance.prolongingEmployee && this.orderAdmittance.prolongingEmployee.key) {
          props.prolongingEmployee = this.orderAdmittance.prolongingEmployee.key
        }
      }
      if (this.orderAdmittance.state === 'AD3' || this.orderAdmittance.state === 'AD5') {
        props.closingDate = this.orderAdmittance.closingEmployee && this.orderAdmittance.closingEmployee.time
        if (this.orderAdmittance.closingEmployee && this.orderAdmittance.closingEmployee.key) {
          props.closingEmployee = this.orderAdmittance.closingEmployee.key
        }
      }
      return props
    },
    onCreateDocumentEmptyTemplate: function (type) {
      const url = '/service/delta/orderadmittance/emptytemplate?brigadeId=' + this.orderAdmittance.brigadeId + '&templateId=' + this.orderAdmittance.templateId + '&format=' + type
      if (type === 'docx') {
        this.onDownloadDocx(url)
      } else if (type === 'pdf') {
        this.$d_pdfViewer.show({
          files:
          [
            {
              src: url,
              name: this.orderAdmittance.templateName
            }
          ]
        })
      }
    },
    onCreateDocument: function (type) {
      if (this.orderAdmittance.state === 'AD0') {
        this.onCreateDocumentEmptyTemplate(type)
        return
      }

      this.$q.loading.show({ spinnerColor: 'blue-11' })
      axiosGet({
        url: '/service/delta/orderadmittance/printDocument?orderAdmittanceIds=' + this.orderAdmittance.id,
        onSuccess: (response) => {
          if (type === 'docx') {
            let docUrl = null
            if (response && response.data && response.data.length) {
              docUrl = response.data[0].docxurl
            }
            if (docUrl) {
              this.onDownloadDocx(docUrl)
            }
          } else if (type === 'pdf') {
            let pdfUrl = null
            if (response && response.data && response.data.length) {
              pdfUrl = response.data[0].pdfurl
            }
            if (pdfUrl) {
              const readonly = this.orderAdmittance.state === 'AD1' || this.orderAdmittance.state === 'AD2'
              this.$d_pdfViewer.show({
                files:
                [
                  {
                    src: pdfUrl + '&attachment=false',
                    name: this.orderAdmittance.name
                  }
                ],
                readonly: readonly
              })
            }
          }

          this.$emit('update')
        },
        onFailure: 'Ошибка при создании документа наряд-допуска'
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    onDownloadDocx: function (url) {
      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute('download', 'Наряд-допуск')
      link.setAttribute('target', '_blank')
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    onUpdateTemplate: function (url) {
      this.$refs.updateTemplate.opened = true
    }
  }
}

